<template>
  <div class="app-footer">
    <div class="app-footer__section">
      <span class="typo-sm-medium">고객센터</span>
    </div>
    <div class="app-footer__section">
      <span class="app-footer__info">전화번호: 02-6954-7682</span>
      <span class="app-footer__info">운영시간: 평일 09시-18시</span>
    </div>
    <div class="app-footer__toggle" @click="isOpen = !isOpen">
      <span class="app-footer__toggle-label">솔닥 주식회사</span>
      <img
        class="app-footer__toggle-icon"
        :class="{ 'app-footer__toggle-icon--open': isOpen }"
        src="@/assets/home/icn_expand_less.png"
        alt="toggle"
      />
    </div>
    <div v-if="isOpen" class="app-footer__detail">
      <span class="app-footer__info">
        서울 강남구 학동로33길 17, 3층<br/>
        사업자등록번호: 284-87-00967<br/>
        통신판매업신고번호: 2021-서울강남-06329<br/>
        대표자명: 김민승, 이호익<br/>
        개인정보관리자: 김민승<br/>
        대표번호: 02-6954-7682<br/>
        이메일: info@soldoc.co.kr<br/>
        ©soldoc Co., Ltd. All Rights Reserved.
      </span>
      <div class="app-footer__links">
        <span class="app-footer__link" @click="openPolicy('terms')">이용약관</span>
        <span class="app-footer__link" style="font-weight: 700;" @click="openPolicy('privacy')">개인정보처리방침</span>
        <span class="app-footer__link" @click="openPolicy('location')">위치기반서비스이용약관</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  data: function () {
    return {
      isOpen: false,
    }
  },
  methods: {
    openPolicy: function (type) {
      window.open('https://policy.soldoc.co.kr/' + type, '_blank')
    },
  },
}
</script>

<style scoped>
.app-footer {
  display: flex;
  padding: 16px 16px 32px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  background: #E5E8EB;
}

.app-footer__section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.app-footer__info {
  color: var(--color-gray-500);
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.app-footer__toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.app-footer__toggle-label {
  color: var(--color-gray-500);
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.app-footer__toggle-icon {
  width: 12px;
  margin-left: 16px;
  transform: rotate(0deg);
  transition: transform 0.2s ease;
}

.app-footer__toggle-icon--open {
  transform: rotate(180deg);
}

.app-footer__detail {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.app-footer__links {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.app-footer__link {
  color: var(--color-gray-500);
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/AppFooter.vue